export const MxFlagAtom = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none">
      <g id="ic_mexico">
        <path
          id="Vector"
          d="M13.333 33.1H.69a.69.69 0 0 1-.69-.689V7.584c0-.381.309-.69.69-.69h12.643V33.1Z"
          fill="#73AF00"
        />
        <path
          id="Vector_2"
          d="M26.667 6.896H13.334v26.207h13.333V6.896Z"
          fill="#F5F5F5"
        />
        <path
          id="Vector_3"
          d="M39.31 33.102H26.667V6.896H39.31c.381 0 .69.308.69.69v24.827a.69.69 0 0 1-.69.69Z"
          fill="#FF4B55"
        />
        <path
          id="Vector_4"
          d="M21.19 20.614 20 21.21v.595h.595l.595-1.19Z"
          fill="#FFD250"
        />
        <g id="Group" fill="#00C3A0">
          <path
            id="Vector_5"
            d="M20.001 23.292a.297.297 0 0 1-.297-.297v-1.19a.297.297 0 1 1 .594 0v1.19a.297.297 0 0 1-.297.297Z"
          />
          <path
            id="Vector_6"
            d="M20 22.104a4.661 4.661 0 0 1-3.176-1.269.297.297 0 0 1 .405-.435A4.068 4.068 0 0 0 20 21.51a4.068 4.068 0 0 0 2.771-1.11.298.298 0 0 1 .405.435A4.66 4.66 0 0 1 20 22.105Z"
          />
        </g>
        <path
          id="Vector_7"
          d="M20 23.29c-.762 0-1.5-.222-2.136-.644l.33-.495a3.317 3.317 0 0 0 3.612 0l.33.495a3.846 3.846 0 0 1-2.136.645Z"
          fill="#00AADC"
        />
        <path
          id="Vector_8"
          d="m19.53 19.276-.657 1.016-.111.334 1.71-.396-.942-.954Z"
          fill="#732D37"
        />
        <path
          id="Vector_9"
          d="M18.18 20.953c-.787 0-1.73-.661-1.98-2.136l.586-.099c.208 1.226.962 1.641 1.415 1.64.139-.004.284-.052.295-.15.013-.117.017-.145-.294-.25-.17-.057-.361-.122-.496-.276-.544-.621.193-1.278.547-1.594.062-.056.088-.104.081-.122-.02-.05-.136-.127-.267-.127-.378 0-.665-.214-.748-.557a.794.794 0 0 1 .388-.89l.273.528c-.073.037-.102.145-.083.221.007.031.025.103.17.103.364 0 .71.215.823.51.048.127.12.454-.24.777-.392.35-.625.612-.496.76.03.033.155.076.238.104.268.09.766.259.695.881-.045.392-.394.664-.87.677h-.037Z"
          fill="#AAD264"
        />
        <path
          id="Vector_10"
          d="M20.595 17.64s.595-1.19-.595-1.784c0 0 4.163-.595 3.568 4.758-.39-.313-.97-.883-1.177-1.338l-1.796-1.041v-.595Z"
          fill="#874150"
        />
        <path
          id="Vector_11"
          d="m20 18.833 2.974 1.784-1.19.595L20 19.428v-.595Z"
          fill="#732D37"
        />
        <path
          id="Vector_12"
          d="M18.81 17.047c.328 0 .595.267.595.595a1.166 1.166 0 0 0-.22 1.346l.135.27c.056.111.13.214.218.302l1.651 1.65v-.821a6.596 6.596 0 0 0-.696-2.95 1.784 1.784 0 0 0-1.596-.986h-.087v.595Z"
          fill="#783C46"
        />
        <path
          id="Vector_13"
          d="m18.81 16.451-.594.595v.595s.707-.359.946-.473c.166-.08.136-.269.04-.36a43.15 43.15 0 0 0-.392-.357Z"
          fill="#FFD250"
        />
        <path
          id="Vector_14"
          d="M20 24.483a5.061 5.061 0 0 1-5.055-5.056h.595c0 2.46 2 4.46 4.46 4.46s4.46-2 4.46-4.46h.595A5.061 5.061 0 0 1 20 24.483Z"
          fill="#AAD264"
        />
        <g id="Group_2" fill="#FFE15A">
          <path
            id="Vector_15"
            d="M15.571 21.593a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
          <path
            id="Vector_16"
            d="M16.464 23.019a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
          <path
            id="Vector_17"
            d="M17.913 24.093a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
          <path
            id="Vector_18"
            d="M24.47 21.593a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
          <path
            id="Vector_19"
            d="M23.577 23.019a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
          <path
            id="Vector_20"
            d="M22.129 24.093a.404.404 0 1 0 0-.807.404.404 0 0 0 0 .807Z"
          />
        </g>
        <path
          id="Vector_21"
          d="M20.297 23.591h-.594a.595.595 0 0 1 0-1.19h.594a.595.595 0 0 1 0 1.19Z"
          fill="#FFB478"
        />
        <path
          id="Vector_22"
          d="M22.391 19.276c.199.582.62 1.115 1.177 1.338C24.163 15.26 20 15.856 20 15.856c2.974 0 2.391 3.42 2.391 3.42Z"
          fill="#9B4B5A"
        />
      </g>
    </svg>
  )
}
